// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { squareListCog16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-square-list-cog': IconSquareListCog;
    }
}

/**
 * The icon component for the 'squareListCog' icon
 */
export class IconSquareListCog extends IconSvg {
    public constructor() {
        super(squareListCog16X16);
    }
}

registerIconSvg('icon-square-list-cog', IconSquareListCog);
export const iconSquareListCogTag = 'nimble-icon-square-list-cog';
